import "./ConfirmModal.css";

const ConfirmModal = ({ handleUpdateSubmit, handleCancelConfirm, orgName }) => {
  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal">
        <h2 className="confirm-modal-heading">Confirm Action</h2>
        <p className="confirm-modal-text">
          Are you sure you want to change <strong>{orgName}</strong>?
        </p>

        <div className="modal-btn-grp">
          <button className="org-modal-btn confirm-modal-btn" onClick={handleUpdateSubmit}>Confirm</button>
          <button className="org-modal-btn cancel-modal-btn" onClick={handleCancelConfirm}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
